"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EMRA_LAB_RESULTS_PAGE_MAX_BYTES () {
        return EMRA_LAB_RESULTS_PAGE_MAX_BYTES;
    },
    get EMRA_LAB_RESULTS_PAGE_MAX_ITEMS () {
        return EMRA_LAB_RESULTS_PAGE_MAX_ITEMS;
    },
    get EmraLabResultsPageV1Schema () {
        return EmraLabResultsPageV1Schema;
    }
});
const _zod = require("zod");
const _result = require("./result");
const EMRA_LAB_RESULTS_PAGE_MAX_ITEMS = 50;
const EMRA_LAB_RESULTS_PAGE_MAX_BYTES = 2 * 1024 * 1024;
const EmraLabResultsPageV1Schema = _zod.z.object({
    results: _zod.z.array(_zod.z.object({
        receivedAt: _result.EmraUtcDateTimeSchema,
        result: _result.EmraLabResultV1Schema
    }).strict()).max(EMRA_LAB_RESULTS_PAGE_MAX_ITEMS)
}).strict();
